import { useState } from "react";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import "./styles/layout.css";
import Dashboard from "./pages/Dashboard";
import FavoriteCourses from "./pages/FavoriteCourses";
import Certificates from "./pages/Certificates";
import AccountSettings from "./pages/AccountSettings";
import { dashboardCard1Object } from "./ExportDashboardCard1Object";

export default function AppDashboard({}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
 const [pageDB, setPageDB] = useState("dashboard");

  return (
    <div className={`app-layout ${sidebarOpen ? "sidebarD-open" : ""}`}>
      <Sidebar dashboardCard1Object={dashboardCard1Object} onClose={() => setSidebarOpen(false)}  pageDB={pageDB} setPageDB={(page)=>{setPageDB(page)}}/>

      {/* Overlay (mobile only) */}
      <div
        className="sidebarD-overlay"
        onClick={() => setSidebarOpen(false)}
      />

      <div className="main-area">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        {/* pages here */}

         {pageDB=="dashboard"?<Dashboard dashboardCard1Object={dashboardCard1Object} />
         :pageDB=="courses"?<FavoriteCourses dashboardCard1Object={dashboardCard1Object}  />
         :pageDB=="certificates"?<Certificates />:pageDB=="settings"?<AccountSettings />:""}
         
      </div>
      <style>{`

.dashboardPageHeaderFont{
  font-family:${dashboardCard1Object?.titleFonts?.headerFont?.family?.fontFamily};;
}

.dashboardPageTitleFont{
  font-family:${dashboardCard1Object?.titleFonts?.titleFont?.family?.fontFamily};;
}
.dashboardPageSubTitleFont{
  font-family:${dashboardCard1Object?.titleFonts?.subtitleFont?.family?.fontFamily};;
}
  .dashboardPageTagsFont{
  font-family:${dashboardCard1Object?.titleFonts?.tagsFont?.family?.fontFamily};;
}
  .dashboardPageButtonFont{
  font-family:${dashboardCard1Object?.titleFonts?.buttonFont?.family?.fontFamily};;
}

/* Hide menu button on desktop */
@media (min-width: 1024px) {
  .menu-btnsidebarD {
    display: none;
  }

  .sidebarD {
    position: static;
    transform: translateX(0);
    width: 240px;
    height: auto;
  }

  .sidebarD-overlay {
    display: none;
  }

  .app-layout {
    flex-direction: row;
  }
}
  /* -----------------------------
   PAGE CONTAINER
------------------------------ */
.pageDashB {
  flex: 1;
  padding: 24px;
  overflow-y: auto;background:#fff;
   padding: 25px;padding-top:5px;
} 
   
/* xs */
@media (max-width: 767px) {
  .pageDashB {
  padding: 5px;
}
}

`}</style>
    </div>
  );
}
